import utils from 'utils'
class stampDutyTaskTrackingCtrl {
  constructor(
    $scope,
    logger,
    httpRequest,
    initSortService,
    $timeout,
    $filter,
    $uibModal,
    sweetalert,
    Upload
  ) {
    $scope.currentUserInfo = JSON.parse(localStorage.user_info).user;
    $scope.select = {}
    $scope.treeConfig = {
        isCheckall: true,
        check: {
            //如果没有设置配置项，取默认配置
            enable: true, //显示不显示复选框
            chkboxType: { Y: '', N: '' },
        },
    }
    //   上月的第一天和最后一天
    const obj = utils.getLastMonthFirstLast()
    $scope.datePickerConfig = {
      clearBtn: true, //清除按钮
    }
    // 所勾选初始的数据
    $scope.selectedRows = []
    // 查询条件
    $scope.param = {
      pageNum: 1,
      pageSize: 10,
      param: {
        companyName: '', //名称
        taxNo: '', //识别号
        applyPeriodEnd: obj.lastDayOfPreMonth,
        applyPeriodStart: obj.firstDayOfPreMonth,
      },
    }
    // 重置
    $scope.reset = function () {
      $scope.belleRegionCityList = []
      $scope.param.param = {
        companyName: '', //名称
        taxNo: '', //识别号
        applyPeriodEnd: obj.lastDayOfPreMonth,
        applyPeriodStart: obj.firstDayOfPreMonth,
      }
    //   queryInfo()
    getUserInfo()
    }
    // 字典数据
    $scope.dictData = {}
    const typecodeArr = [
      'fill_in_status', //填写状态
      'stamp_duty_reporting_period', //申报周期
      'declaration_status', //申报状态
      'payment_status', //缴款状态
      'department_no', //事业部
      'yes_no_flag',
    ]
    httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
      $scope.dictData = $.extend($scope.dictData, res.data.value)
    })
    // 主管税局所在省市
    httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
      $scope.dictDataProvince = res.data.value
    })
    // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
    httpRequest.get_getBelleRegion().then((res) => {
      $scope.belleRegionList = res.data.value
    })
    // 获取管理城市时两个都要传
    $scope.$watch('param.param.regionName', function (newVal, oldVal) {
      //重置
      if ($scope.param.param.regionName == undefined) {
        $scope.belleRegionCityList = []
        return
      }
      angular.forEach($scope.dictData.department_no, function (item, index) {
        if (item.enumName === $scope.param.param.departmentNo) {
          $scope.departmentNo = item.enumCode
        }
      })
      angular.forEach($scope.belleRegionList, function (item, index) {
        if (item.regionName === newVal) {
          $scope.regionNo = item.treeLevelCode
        }
      })
      let params = {
        affiliation: $scope.departmentNo,
        regionNo: $scope.regionNo,
      }
      if (params.affiliation == '' || params.regionNo == '') return
      httpRequest.get_getBelleRegion(params).then((res) => {
        $scope.belleRegionCityList = res.data.value
      })
    })

    //申报
    $scope.declare = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      const selectedRowIdList = []
      angular.forEach($scope.selectedRows, function (item, index, array) {
        selectedRowIdList.push(item.id)
      })
      let declareMapArr = selectedRowIdList.map(String)
      httpRequest.post_batchDeclare(declareMapArr, false).then((res) => {
        let declareData = res.data.value
        if (declareData.length > 0) {
          logger.logError(declareData[0].msg)
        } else {
          logger.logSuccess('申报成功，请等待RPA操作。')
          queryInfo()
        }
      })
    }
    // 打开申报弹窗
    function showCollectionDialog() {
      return $uibModal.open({
        templateUrl: 'origin-account-collect-dialog.html',
        controller: collectDialogCtrl,
        backdrop: 'static',
        openedClass: 'mod-modal mod-modal-md',
        resolve: {
          items1() {
            return $scope.selectedRows
          },
        },
      }).result
    }
    //交款
    $scope.Pay = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      let selectedRowIdList = []
      angular.forEach($scope.selectedRows, function (item, index, array) {
        selectedRowIdList.push(item.id)
      })
      let PayIdArr = selectedRowIdList.map(String)
      httpRequest.post_batchPay(PayIdArr, false).then((res) => {
        let batchPayData = res.data.value
        if (batchPayData.length > 0) {
          logger.logError(batchPayData[0].msg)
        } else {
          logger.logSuccess('缴款成功，请等待RPA操作。')
          queryInfo()
        }
      })
    }
    // 删除
    $scope.batchDeletion = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      let selectedRowIdList = []
      try {
        angular.forEach($scope.selectedRows, function (item, index, array) {
          if (item.declarationStatus == 1 || item.declarationStatus == 2) {
            throw new Error(true)
          }
          selectedRowIdList.push(item.id)
        })
      } catch (e) {
        if (e)
          logger.logTips('申报状态为"申报成功"/"待RPA申报"的任务不允许删除，请检查数据！', 'warn')
        return
      }
      let deleteMapArr = selectedRowIdList.map(String)
      $scope.comfirmDeletion(deleteMapArr)
    }
    $scope.comfirmDeletion = function (arr) {
      sweetalert.confirm('操作提醒', '确认删除该任务任务跟踪信息？').then(() => {
        httpRequest.post_batchDelete(JSON.stringify(arr), '删除成功').then((res) => {
          queryInfo()
          // 重置
          $scope.selectedRows = []
        })
      })
    }

    // 查询展开
    $scope.isFilterCollapsed = false
    $scope.customizedConfig = {
      version: 5.5,
      queryConfig: [
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '数据填写状态',
          selected: true,
          default: true,
        },
        {
          label: '申报状态',
          selected: true,
          default: true,
        },
        {
          label: '缴款状态',
          selected: true,
          default: true,
        },
        {
          label: '税款所属期起',
          selected: true,
          default: true,
        },
        {
          label: '税款所属期止',
          selected: true,
          default: true,
        },
        {
          label: '本期应补（退）税额',
          selected: false,
          default: false,
        },
        {
          label: '事业部',
          selected: false,
          default: false,
        },
        {
          label: '所属大区',
          selected: false,
          default: false,
        },
        {
          label: '主管税局所在省市',
          selected: false,
          default: false,
        },
        {
          label: '申报周期',
          selected: false,
          default: false,
        },
        {
          label: '管理城市',
          selected: false,
          default: false,
        },
        {
          label: '是否变更缴款状态',
          selected: false,
          default: false,
        },
        {
          label: '跟进人',
          selected: false,
          default: false,
        },
      ],
      table: [
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '税款所属期起',
          selected: true,
          default: true,
        },
        {
          label: '税款所属期止',
          selected: true,
          default: true,
        },
        {
          label: '数据填写状态',
          selected: true,
          default: true,
        },
        {
          label: '申报状态',
          selected: true,
          default: true,
        },
        {
          label: '缴款状态',
          selected: true,
          default: true,
        },
        {
          label: '本期应补（退）税额',
          selected: true,
          default: true,
        },
        {
          label: '事业部',
          selected: false,
          default: false,
        },
        {
          label: '所属大区',
          selected: false,
          default: false,
        },
        {
          label: '主管税局所在省市',
          selected: false,
          default: false,
        },
        {
          label: '申报周期',
          selected: false,
          default: false,
        },
        {
          label: '管理城市',
          selected: false,
          default: false,
        },
        {
          label: '异常消息提示',
          selected: false,
          default: false,
        },
        {
          label: '是否变更缴款状态',
          selected: false,
          default: false,
        },
        {
          label: '跟进人',
          selected: false,
          default: false,
        },
      ],
    }
    $scope.currentPage = 1 // 设置显示第一页
    $scope.maxSize = 10 // 每一页显示记录数
    $scope.pageChanged = function () {
      // 点击页码发起查询
      queryInfo()
    }
    function queryInfo() {
      const openLoading =
        $scope.param.pageSize >= 100
          ? window.layer.msg('正在查询，请耐心等待', {
              time: 0,
              skin: 'layer-loading-self',
              icon: 16,
              shade: 0.5,
            })
          : null
      httpRequest
        .post_getRpaStampDutyTaskDtoList(JSON.stringify(queryDataHandle($scope.param)))
        .then((res) => {
          $scope.listData = res.data.value.list
          // 获取后台分页数据 回写分页组件
          $scope.totalItems = res.data.value.total
          $scope.param.pageNum = res.data.value.pageNum
          $scope.param.pageSize = res.data.value.pageSize
        })
        .finally(() => {
          window.layer.close(openLoading)
        })
    }
    // queryInfo()
    function queryDataHandle(queryData) {
        $scope.employeeList = []
        const { selectedFollower } = $scope.select
        selectedFollower.forEach(item => {
            $scope.employeeList.push({employeeName:item.employeeName, employeeNumber:item.employeeNumber})
        });
        queryData.param.employeeList = $scope.employeeList

        return queryData
    }

    $scope.searchlist = function () {
      queryInfo()
    }
    // 模板下载
    $scope.downloadExcel = function () {
      window.open(
        `${
          host.etcloudIvatApp
        }dl/dlTaskService/export_SB_STAMP_DUTY?accessToken=${localStorage.getItem('id_token')}`
      )
    }
    // 申报表导入
    $scope.uploadFiles = function uploadFiles(file, errFiles) {
      if (file == null && errFiles.length >= 1) {
        logger.logError('文件类型错误，文件大小不超过5MB，只支持.xlsx,.xls格式文件导入')
        return
      }
      if (file) {
        file.upload = Upload.upload({
          url: `${host.etcloudIvatApp}taxdeclaration/rpaGsConfig/importBill`,
          data: {
            importFile: file,
            code: 'SB_STAMP_DUTY',
          },
        })
        // 文件上传
        // loading动画
        const importinglayer = layer.msg('玩命上传中，请耐心等待', {
          time: 0,
          skin: 'layer-loading-self',
          icon: 16,
          shade: 0.5,
        })
        file.upload.then(
          (res) => {
            $timeout(() => {
              if (!res.data.success) {
                layer.close(importinglayer)
                return logger.logError(res.data.message || '上传失败')
              }
              if (res.data.value.sourceCount === 0) {
                layer.close(importinglayer)
                return logger.logTips('导入数据为空！', 'warn')
              }
              const { batchNo, sourceCount, errorCount } = res.data.value
              // 结果弹框
              // if (res.data.value.errorCount > 0) {
              httpRequest
                .post_getPageDlBatchInfoList({
                  pageNum: 1,
                  pageSize: 10,
                  param: res.data.value.batchNo,
                })
                .then((res1) => {
                  layer.close(importinglayer)
                  $scope.importResultModal({
                    batchNo,
                    sourceCount,
                    successCount: sourceCount - errorCount,
                    errorCount,
                    data: res1.data.value,
                  })
                  queryInfo()
                })
            })
          },
          (response) => {}
        )
      }
    }
    // 导入结果弹窗
    $scope.importResultModal = function (modalData) {
      const modalInstance = $uibModal.open({
        templateUrl: 'importResult.html',
        controller: [
          '$scope',
          '$uibModalInstance',
          'logger',
          'items1',
          function ($scope, $uibModalInstance, logger, items1) {
            $scope.modalData = items1
            $scope.list = items1.data.list
            console.log($scope.modalData)
            $scope.pageOptions = {
              // 分页器
              totalItems: $scope.modalData.data.total,
              currentPage: ++$scope.modalData.data.prePage,
              maxSize: $scope.modalData.data.pageSize,
            }
            // 关闭
            $scope.ok = () => {
              $uibModalInstance.close()
            }
            // 分页查询
            $scope.pageChanged = () => {
              queryList()
            }
            // 导出错误详情
            $scope.downBatchInfo = function () {
              window.open(
                `${host.etcloudIvatApp}dl/dlTaskService/downBatchInfoDetail?batchNo=${$scope.modalData.batchNo}&accessToken=${localStorage.id_token}`
              )
            }
            function queryList() {
              httpRequest
                .post_getPageDlBatchInfoList({
                  pageNum: $scope.pageOptions.currentPage,
                  pageSize: $scope.pageOptions.maxSize,
                  param: $scope.modalData.batchNo,
                })
                .then((res) => {
                  $scope.list = res.data.value.list
                  $scope.pageOptions = {
                    // 分页器
                    totalItems: res.data.value.total,
                    currentPage: ++res.data.value.prePage,
                    maxSize: res.data.value.pageSize,
                  }
                })
            }
          },
        ],
        backdrop: 'static',
        openedClass: 'mod-modal-importexcel',
        windowClass: 'mod-modal mod-modal-lg',
        bindToController: true,
        resolve: {
          items1() {
            return modalData
          },
        },
      })
      modalInstance.result.then(
        () => {},
        () => {}
      )
    }
    //导出
    $scope.exportExel = function exportExel() {
      let fileName = '申报任务跟踪(印花税)'
      let url = `${
        host.etcloudIvatApp
      }taxdeclaration/rpaGsTask/exportList?accessToken=${localStorage.getItem('id_token')}`
      utils.file_download(
        url,
        $scope.param.param,
        'stamp_dutytask', //type
        'POST',
        'blob',
        fileName,
        false
      )
    }
    // 还原
    $scope.reduction = (type) => {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选择数据后操作')
      }
      try {
        angular.forEach($scope.selectedRows, (item, index) => {
          if (item.declarationStatus == 2 || item.declarationStatus == 3) {
            logger.logError('申报已成功，不允许还原，请检查。')
            throw new Error('break')
          }
        })
      } catch (e) {
        // console.log(e,'跳出');
        return
      }
      let params = {
        ids: [],
        type,
      }
      for (let i = 0; i < $scope.selectedRows.length; i++) {
        params.ids.push($scope.selectedRows[i].id)
      }
      sweetalert
        .confirm(
          '还原提示',
          '确认需要对选择的数据进行还原操作，确认请点击【确定】按钮，否则点击【取消】按钮。'
        )
        .then(() => {
          httpRequest.post_reductionStatus(params).then((res) => {
            logger.logSuccess('还原成功')
            queryInfo()
          })
        })
    }
    $scope.changePaymentStatus = (status) => {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      const idList = $scope.selectedRows.map((item) => item.id).map(String)
      if (Object.is(status, 0)) {
        return httpRequest
          .post_rpaStampDutyTaskChangeRpaTaskPayment({ idList, status })
          .then((res) => {
            logger.logSuccess('取消变更缴款状态成功')
            setTimeout(() => {
              queryInfo()
            }, 2000)
          })
      }
      sweetalert
        .confirm(
          '变更缴款状态提醒',
          '仅缴款状态为未缴款/缴款失败/待RPA缴款的数据支持变更缴款状态，其余状态的数据将自动过滤，确认需要对选择的数据进行变更缴款状态为“人工缴款成功”吗？'
        )
        .then(() => {
          httpRequest.post_rpaStampDutyTaskChangeRpaTaskPayment({ idList, status }).then((res) => {
            logger.logSuccess('变更缴款状态成功')
            setTimeout(() => {
              queryInfo()
            }, 2000)
          })
        })
    }
    function getUserInfo() {
        $scope.params = {
            pageSize: 2000,
            pageNum: 1,
            param: {
                isRoleOwner: '1', // 拥有本机构角色
                orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
            },
        }
        httpRequest.get_getIvatEmployeeList().then((res) => {
            $scope.followerList = dataHandle(res.data.value)
            $scope.select.selectedFollower =  $scope.followerList.filter((x) => { return x.employeeName == $scope.currentUserInfo.realName})
            queryInfo()
        })
    }
    getUserInfo()
    function dataHandle(list) {
        list.forEach((el,index) => {
            el.orgId = index
            el.orgName = el.employeeName + '|' + el.employeeNumber
            if ($scope.currentUserInfo.realName == el.employeeName) {
                el.checked = true
            } else {
                el.checked = false
            }
        })
        return list
    }
  }
}
stampDutyTaskTrackingCtrl.$inject = [
  '$scope',
  'logger',
  'httpRequest',
  'initSortService',
  '$timeout',
  '$filter',
  '$uibModal',
  'sweetalert',
  'Upload',
]
export default stampDutyTaskTrackingCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/stampDuty/stampDutyTaskTracking/stampDutyTaskTrackingCtrl.js